import { Browser } from '@capacitor/browser';
import { useState } from 'react';
import { usePlatform } from './usePlatform';

export interface OpenWindowOptions {
  replaceCurrentWindow?: boolean;
}

export const useWindow = () => {
  const [openedWindow, setOpenedWindow] = useState<Window>();
  const { isNative } = usePlatform();

  const openWindow = (url: string, options?: OpenWindowOptions) => {
    if (isNative) {
      void Browser.open({
        url: url,
      });
    } else {
      const target = options?.replaceCurrentWindow ? '_self' : '_blank';

      const newWindow = window.open(url, target);
      if (newWindow) {
        setOpenedWindow(newWindow);
      }

      return newWindow || undefined;
    }
  };
  const closeWindow = () => {
    if (isNative) {
      Browser.close().catch(console.warn);
    } else if (openedWindow) {
      openedWindow.close();
      setOpenedWindow(undefined);
    }
  };

  return {
    openWindow,
    closeWindow,
  };
};
